export default {
    // 查询数据库列表信息
    queryDbInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/queryDbInfo', params, response);
    },

    // 查询数据库类型
    listAllDbTypes(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/listAllDbTypes', params, response);
    },

    // 添加数据库信息
    insertDbInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/insertDbInfo', params, response);
    },

    // 更新数据库信息
    updateDbInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/updateDbInfo', params, response);
    },

    // 删除数据库列表信息
    deleteDbInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/deleteDbInfo', params, response);
    },

    // 数据库连接测试
    connectDbTest(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/connectDbTest', params, response);
    },

    // 检测ip和名称是否重复
    checkIpNameRepeat(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/databaseController/checkIpNameRepeat', params, response);
    }
};
